"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTemplateWithTheme = void 0;
function formatTemplateWithTheme(formatTemplate, theme) {
    const f = formatTemplate;
    return {
        container: f['container'](theme),
        searchLabel: f['searchLabel'](theme),
        searchInput: f['searchInput'](theme),
        localeLabel: f['localeLabel'](theme),
        localeInput: f['localeInput'](theme),
        button: f['button'](theme),
        autoComplete: f['autoComplete'](theme),
        extLink: f['extLink'](theme),
        emptySearchError: f['emptySearchError'](theme)
    };
}
exports.formatTemplateWithTheme = formatTemplateWithTheme;
//# sourceMappingURL=formatTemplateWithTheme.js.map